export const newsConstants = {
  SET_NEWS_SUCCESS: 'SET_NEWS_SUCCESS',
  SET_NEWS_FAILURE: 'SET_NEWS_FAILURE',

  SET_NEWS_LIST_SUCCESS: 'SET_NEWS_LIST_SUCCESS',
  SET_NEWS_LIST_FAILURE: 'SET_NEWS_LIST_FAILURE',

  SET_NEWS_PROMO_SUCCESS: 'SET_NEWS_PROMO_SUCCESS',
  SET_NEWS_PROMO_FAILURE: 'SET_NEWS_PROMO_FAILURE',
  RESET_NEWS_PROMO: 'RESET_NEWS_PROMO',

  SET_MY_NEWS_LIST_SUCCESS: 'SET_MY_NEWS_LIST_SUCCESS',
  SET_MY_NEWS_LIST_FAILURE: 'SET_MY_NEWS_LIST_FAILURE',

  SET_MY_NEWS_PROMO_SUCCESS: 'SET_MY_NEWS_PROMO_SUCCESS',
  SET_MY_NEWS_PROMO_FAILURE: 'SET_MY_NEWS_PROMO_FAILURE',
  RESET_MY_NEWS_PROMO: 'RESET_MY_NEWS_PROMO',

  SET_NEW_OFFERS_NEWS_SUCCESS: 'SET_NEW_OFFERS_NEWS_SUCCESS',
  SET_NEW_OFFERS_NEWS_FAILURE: 'SET_NEW_OFFERS_NEWS_FAILURE',
};
